import React from 'react'
import { Label } from './styles'

type Props = {
  children?: string
  htmlFor?: string
  style?: object
  text?: string
}

const InputLabel: React.FC<Props> = (props: Props) => {
  return (
    <Label htmlFor={props.htmlFor} style={props.style}>
      {props.children || props.text}
    </Label>
  )
}

export default InputLabel
